import { AdaptiveLoader } from "./AdaptiveLoader"

interface Props {
  minWidth?: string
  minHeight?: string
  ariaLabel?: string
  size?: number
  opacity?: number
}

// Props are not forwarded to the <div>: they aren't valid DOM attributes.
export const Loader = ({
  size,
  ariaLabel,
  opacity = 1,
  minWidth = "100%",
  minHeight = "100%",
}: Props) => (
  <div
    className="flex w-full flex-col items-center justify-center rounded-[0.1875rem] bg-secondary_subtle fill-(--text-primary) text-primary"
    style={{
      // keeping these as dynamic classes will not be picked up by tailwindcss
      opacity,
      minWidth,
      minHeight,
    }}
  >
    <AdaptiveLoader size={size || 50} speed={1.4} ariaLabel={ariaLabel} />
  </div>
)
